import { useContractOrdererStore } from '@/hooks/use-contract-orderer'
import { useI18n } from 'i18n-utils'
import { useDoubleContractOrderListStore } from 'store'
import { ArrowDownIcon, DialogHeader, HocElDialog, UiUtils, useDialog } from 'ui-components'
import '../styles/leverage-layout.scss'
import { UpdateLeverage } from './UpdateLeverage'

export const Leverage = defineComponent({
  setup() {
    const orderer = useContractOrdererStore()
    const { openDialog, closeDialog, dialogVisible } = useDialog()
    const { t } = useI18n()
    const orderListStore = useDoubleContractOrderListStore()

    const isRenderUpdateLeverage = ref(false)

    const onOpenLeverageDialog = () => {
      if (orderListStore.currentPositions.length > 0 || orderListStore.currentLimitOrders.length > 0) {
        return UiUtils.showError(t('当前有进行中的仓位或委托单，不能修改杠杆'))
      }
      openDialog()
    }

    watch(
      () => dialogVisible.value,
      (newVal) => {
        if (newVal) {
          isRenderUpdateLeverage.value = true
        } else {
          setTimeout(() => {
            isRenderUpdateLeverage.value = false
          }, 300)
        }
      },
    )

    return () => (
      <>
        <div class="leverage-layout" onClick={onOpenLeverageDialog}>
          {orderer.currentLeverage}X
          <ArrowDownIcon />
        </div>

        <HocElDialog v-model={dialogVisible.value} width={430} placement="bottom" onClose={closeDialog} showClose={false}>
          {{
            header: () => <DialogHeader onClose={closeDialog}>{t('调整杠杆')}</DialogHeader>,
            default: () => {
              return isRenderUpdateLeverage.value ? <UpdateLeverage onSuccess={closeDialog} /> : null
            },
          }}
        </HocElDialog>
      </>
    )
  },
})
